// src/queryClient.js
import { QueryClient } from '@tanstack/react-query';
import { isAbortError } from './utils/httpCancel';

// Shared client for every useQuery/useMutation call in the app.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      // This app already drives refetches via explicit filter/param changes;
      // an implicit window-focus refetch would fight that and cause flicker.
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isAbortError(error)) return false;
        // Don't retry 4xx — those won't succeed on retry.
        const status = error?.response?.status;
        if (status != null && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
    },
  },
});
